import { Routes, Route, Navigate } from "react-router-dom";
import { StaffLayout } from "../layout/StaffLayout";
import { StaffView } from "../../pages/Staff/StaffView";
import { Settings } from "../../pages/Settings";
import { Profile } from "../../pages/Settings/Profile";
import { Security } from "../../pages/Settings/Security";
import { ErrorBoundary } from "../organisms/ErrorBoundary";

/**
 * Staff Delivery Routes - Simplified mobile interface for delivery drivers
 * Routes: /staff (deliveries + quick sale), /settings
 */
export function StaffDeliveryRoutes() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route
          path="/staff"
          element={
            <StaffLayout>
              <StaffView />
            </StaffLayout>
          }
        />
        <Route
          path="/settings"
          element={
            <StaffLayout>
              <Settings />
            </StaffLayout>
          }
        />
        <Route
          path="/settings/profile"
          element={
            <StaffLayout>
              <Profile />
            </StaffLayout>
          }
        />
        <Route
          path="/settings/security"
          element={
            <StaffLayout>
              <Security />
            </StaffLayout>
          }
        />
        <Route path="*" element={<Navigate to="/staff" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
